module.exports = require("progress-bar-webpack-plugin");